// extracted by mini-css-extract-plugin
module.exports = {"dashboardPage":"dashboardPage__4Gvrm"};